/* eslint-disable react/no-danger -- Markdown*/
/** @typedef	{import("./Types/BlogsCardProps").default} Props */

import { date } from '@mooveguru/js-utilities';
import { translate } from '../../Internationalization';
import CopyToClipboard from '../../../shared/Links/CopyToClipboard';
import React, { useEffect, useRef, useState } from 'react';
import SocialMediaLinks from '../../../shared/SocialMediaLinks';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export default function BlogCard(props) {
	const [isCopied, setIsCopied] = useState(false);
	const copyResetTimeout = useRef(
		/** @type {ReturnType<typeof setTimeout> | null} */ (null)
	);
	const socialShareUrl = `https://blog.homekeepr.io/${props.slug}`;
	const shareableUrl = `${socialShareUrl}?tenant=${window.location.hostname}&sharedby=${props.agentSlug}`;

	useEffect(
		() => () => {
			if (copyResetTimeout.current !== null) {
				clearTimeout(copyResetTimeout.current);
				copyResetTimeout.current = null;
			}
		},
		[]
	);

	function handleCopySuccess() {
		if (copyResetTimeout.current !== null) {
			clearTimeout(copyResetTimeout.current);
			copyResetTimeout.current = null;
		}

		setIsCopied(true);
		copyResetTimeout.current = setTimeout(() => {
			setIsCopied(false);
			copyResetTimeout.current = null;
		}, 2000);
	}

	function body() {
		return (
			<div>
				<img
					alt={props.title}
					className="card-image"
					src={props.imageUrl}
				/>

				<div
					className={`flex flex-col flex-grow border rounded rounded-t-none border-t-0 border-grey-300 ${
						props.isGated ? '' : 'rounded-b-none'
					}`}
				>
					<div className="flex-grow p-4">
						<h2
							className="hl-ms-4 mb-4 text-black"
							dangerouslySetInnerHTML={{
								__html: props.title,
							}}
						/>

						<p className="font-thin text-grey-500 mb-4">
							{date.convertDateToDateString(props.date)}
						</p>

						<p className="text-black">
							<span
								dangerouslySetInnerHTML={{
									__html: props.content,
								}}
							/>{' '}
							<span className="text-sm font-bold whitespace-nowrap">
								{translate(
									'agent.pages.widgets.blog.read_more'
								)}
								{'\u27F6'}
							</span>
						</p>
					</div>
				</div>
			</div>
		);
	}

	if (props.isGated) {
		return body();
	}

	return (
		<div>
			<a
				className="flex flex-col"
				href={shareableUrl}
				key={props.slug}
				rel="noopener noreferrer"
				target="_blank"
			>
				{body()}
			</a>
			<footer className="p-4 border border-t-0 rounded rounded-t-none border-grey-300">
				<section className="justified-row">
					<span className="font-header text-grey-900 -text-ms-1 font-bold">
						{translate('homeowner.pages.dashboard.blog.share')}
					</span>
					<section className="button-group">
						<SocialMediaLinks
							blogPreview={true}
							date={props.date}
							imageUrl={props.imageUrl}
							title={props.title}
							url={socialShareUrl}
						/>
						<CopyToClipboard
							onSuccess={handleCopySuccess}
							text={translate(
								isCopied
									? 'global.links.copied'
									: 'global.links.copy'
							)}
							url={shareableUrl}
						/>
					</section>
				</section>
			</footer>
		</div>
	);
}
